import React from 'react';
import Logger from '../../common/Logger';
import { useModelContext } from '../../context/ModelContext';
import { ItemSeriesProvider } from './DataProvider';
import NivoRadar from './NivoRadar';

const logger = new Logger("rating.RatingChartRadar");

/**
 * Display the RatingValue's for specified items using a radar chart
 */
export function RatingChartRadar(props:any) {
  const model = useModelContext().model;
  const items = props.items;
  const measure = props.measure;

  if (!items || items.length === 0) {
    return <></>;
  }
  
  const series = new ItemSeriesProvider(model, measure, items);

  logger.debug("Rendering:", series);
 
  return (
    <div className="chart-rating">
      <NivoRadar data={series.data} keys={series.keys} getValueLabel={getValueLabel} indexBy="name" />
   </div>
  );

  function getValueLabel(value:number) : string {
    return series.getScaleItemName(value);
  }
}

